import reportService from '../../services/report-service ';
import { stat } from 'fs';



const state = {

  rptloading: false,

  revenue: [],
  expenses: [],
  banktrans:[],
  banktrans_data:{
    cash_at_bank:0,
    bacc_summaries:[]

  },
  revenue_data: {
    all_sales: {},
    cash_sale_sum: 0,
    credit_sale_sum: 0,
    credit_payments_sum: 0,
    goods_sold_cost_sum:0,
    credit_payments:[],
    vendor_sale_sums: [] //vendor  report sums (vcass)
  },
  expenses_data: {
    ov_expense: 0.00, //overall expense
    ov_expense_payable: 0.00, //overall expense payable
    ov_expense_paid: 0.00, //overall expense paid
    expla_summaries:[] //expense ledger account summaries
  },
  error: null,

}

const actions = {

  getRpt({ commit }, data) {
    commit('ResetRpt')
    commit('Loading',true);
    commit('Failure', null)
    reportService.getRpt(data).then(
      response => {
        // console.log("from store",response.data)
        commit('Rpt', response.data)
        commit('Loading',false);
      },
      error => {
        commit('Failure', error)
        commit('Loading',false);
      }
    )
  }
}


const mutations = {
  Loading(state,payload) {
    //console.log(payload)
    state.rptloading = payload;
  },

  ResetRpt(state){

    state.revenue= [];
    state.expense=[];
    state.banktrans=[];

    state.banktrans_data = {
      cash_at_bank:0,
      bacc_summaries:[]
    }

    state.revenue_data ={
      all_sales: {},
      cash_sale_sum: 0,
      credit_sale_sum: 0,
      credit_payments_sum: 0,
      goods_sold_cost_sum:0,
      credit_payments:[],
      vendor_sale_sums: [] //vendor  report sums (vcass)
    }

    state.expenses_data ={
      ov_expense: 0.00, //overall expense
      ov_expense_payable: 0.00, //overall expense payable
      ov_expense_paid: 0.00, //overall expense paid
      expla_summaries:[] //expense ledger account summaries
    }
  },
  Rpt(state, val) {
    //console.log(val)
    state.loading = false
    state.revenue = val.revenue //revenue is from sales
    state.expenses = val.expenses
    state.banktrans = val.banktrans


    //console.log(state.revenue)
    let groupSales = {
      cashSales: [],
      creditSales: []
    };

    let creditSalesDebtPayments = [];

    //grouping reports to credit and cash
    val.revenue.forEach(x => {
      if (x.mop === "Cash") {
        groupSales.cashSales.push(x);
      }
      if (x.mop === "Credit") {
        groupSales.creditSales.push(x);
      }
    });

    //putting all credit report debt payments into 1 array
    if (groupSales.creditSales && groupSales.creditSales.length > 0) {
      creditSalesDebtPayments = groupSales.creditSales
        .map(c => {
          return c.debtpayments;
        })
        .reduce((pre, curr) => {
          return [...pre, ...curr];
        });

        state.revenue_data.credit_payments = creditSalesDebtPayments?creditSalesDebtPayments:[]

        //console.log(state.revenue_data.credit_payments)
    }

    //setting report data to be used in report
    state.revenue_data.all_sales = groupSales;

    //console.log(groupSales)
    
    state.revenue_data.goods_sold_cost_sum =state.revenue &&state.revenue[0]&& state.revenue[0].gssum?state.revenue.reduce((sum,rev)=>{
          return sum+=parseFloat(rev.gssum)
    },0) : 0;

    //console.log(state.revenue_data.goods_sold_cost_sum)

    state.revenue_data.credit_sale_sum =
      groupSales && groupSales.creditSales
        ? groupSales.creditSales.reduce((sum, x) => {
          return (sum += parseFloat(x.payable_amount));
        }, 0)
        : 0;

    state.revenue_data.cash_sale_sum =
      groupSales && groupSales.cashSales
        ? groupSales.cashSales.reduce((sum, x) => {
          return (sum += parseFloat(x.payable_amount));
        }, 0)
        : 0;

    state.revenue_data.credit_payments_sum = creditSalesDebtPayments
      ? creditSalesDebtPayments.reduce((sum, x) => {
        return (sum += parseFloat(x.amount));
      }, 0)
      : 0;

    //grouping vendor sale sums
    state.revenue_data.vendor_sale_sums = groupVendorSaleSum(
      val.revenue
    );


    //overall expenses
    state.expenses_data.ov_expense = val.expenses.map(e => {
      return parseFloat(e.dr)
    }).reduce((sum, val) => {
      return sum += parseFloat(val)
    }, 0)

    //paid expenses
    state.expenses_data.ov_expense_paid = val.expenses.map(e => {
      return parseFloat(e.cr);
    }).reduce((sum, val) => {
      return sum += parseFloat(val)
    }, 0)

    //expenses payable
    state.expenses_data.ov_expense_payable = (state.expenses_data.ov_expense ? parseFloat(state.expenses_data.ov_expense) : 0) - (state.expenses_data.ov_expense_paid ? parseFloat(state.expenses_data.ov_expense_paid) : 0)

   
   
    let lasumresult = []
    state.expenses.forEach(function(a){
      if(!this[a.ledgeracc_id]){
        this[a.ledgeracc_id] = {ledgeracc:a.ledgeracc.name,dr:0,cr:0}
        lasumresult.push(this[a.ledgeracc_id])
      }

      this[a.ledgeracc_id].dr+=parseFloat(a.dr)
      this[a.ledgeracc_id].cr+=parseFloat(a.cr)
    },Object.create(null))


   
    
    
    state.expenses_data.expla_summaries = lasumresult

    let basumresult = []

    state.banktrans?state.banktrans.forEach(function(b){
      if(!this[b.bankacc_id]){
        this[b.bankacc_id] = {bankacc:b.bankacc.bank_name+' ('+b.bankacc.acc_num+')',dr:0,cr:0}
        basumresult.push(this[b.bankacc_id])
      }

      if(b.tran_type=='debit'){
        this[b.bankacc_id].dr+=parseFloat(b.amount)
      }else{
        this[b.bankacc_id].cr+=parseFloat(b.amount)
      }
      
      
    },Object.create(null)):0

    state.banktrans_data.bacc_summaries = basumresult

    
    state.banktrans_data.cash_at_bank = val.bankaccs?val.bankaccs.reduce((sum,b)=>{
      return sum+=parseFloat(b.balance)
    },0):0

  
   

  
  },

  Failure(state, error) {
    state.error = error;
    state.loading = false;
  }
}

const getters = {


  REVENUE: state => {
    return state.revenue
  },
  BANKTRANS: state => {
    return state.banktrans
  },
  EXPENSES: state => {
    return state.expenses
  },
  REVENUE_DATA: state => {
    return state.revenue_data
  },
  BANKTRANS_DATA: state => {
    return state.banktrans_data
  },
  EXPENSES_DATA: state => {
    return state.expenses_data
  },
  REPORT_ERROR: state => {
    return state.error
  },
  REPORT_LOADING: state => {
    return state.rptloading
  },

}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}


export function groupVendorSaleSum(sales) {
  if (sales && sales.length > 0) {
    let c = sales.reduce(
      (groups, item) => ({
        //grouped sales
        ...groups,
        [item.staff]: [...(groups[item.staff] || []), item]
      }),
      []
    );

   

    // console.log("ccccc", c);

    let vsgrpd = c
      ? Object.keys(c).map(key => {
        var oneVendorSales = c[key]; //picking group of individual vendor sales to calculate total report (on cash/credit based on report param) by that vendor
        
        return {
          vendor: key,
          cs: oneVendorSales.reduce((sum, x) => {
            if (x.mop == "Cash") {
              return sum += parseFloat(x.payable_amount);
            }else{
              return sum+=0
            }
          }, 0),
          crs: oneVendorSales.reduce((sum, x) => {
            if (x.mop == "Credit") {
              return sum += parseFloat(x.payable_amount);
            }else{
              return sum+=0
            }
          }, 0)
        };
      })
      : null;

      //console.log(vsgrpd)
    return vsgrpd;
  }
}